import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const ORGANIZATIONS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"organizations"> =
  {};
